import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStore, AuthStore } from '@app/core/states';

export const authGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const appStore = inject(AppStore);
  const router = inject(Router);

  if (authStore.isAuthenticated() && appStore.isAuthorized()) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  const returnUrl = state.url;
  return router.createUrlTree(['/login'], { queryParams: { returnUrl } });
};
